import React, { createContext, useState } from "react";
export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [type, setType] = useState("");

  const [otpSent, setOTPSent] = useState("");

  const [verifyId, setVerifyId] = useState(null);

  const [registerUser, setRegisterUser] = useState("");

  const resetState = () => {
    // setPayloadObj(null);
    setType(null);
    setOTPSent("");
    setVerifyId(null);
  };

  return (
    <AuthContext.Provider
      value={{
        type,
        setType,
        resetState,
        otpSent,
        setOTPSent,
        setVerifyId,
        verifyId,
        setRegisterUser,
        registerUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
